<template>
  <span :title="title" :style="{ ...svgStyle, display: 'flex !important' }">
    <svg class="svg-icon" aria-hidden="true" :style="svgStyle">
      <use :xlink:href="iconName" />
      <defs v-if="isGradientVisible">
        <linearGradient :id="gradientId" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" />
          <stop offset="100%" />
        </linearGradient>
      </defs>
    </svg>
  </span>
</template>

<script>
export default {
  name: "icon-svg",
  props: {
    iconClass: {
      type: [String],
      required: true,
      default: ''
    },
    title: String,
    size: {
      type: [Number, String],
      default: 16
    },
    isGradientVisible: Boolean,
    gradientId: String,
  },
  computed: {
    iconName() {
      return this.iconClass && `#${this.iconClass}`;
    },
    svgStyle() {
      return {
        width: this.size.toString().includes('px') ? this.size : `${this.size}px`,
        height: this.size.toString().includes('px') ? this.size : `${this.size}px`
      }
    }
  },
};
</script>

<style>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>